import React, { lazy } from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import LazySection from './LazySection';
import SEO from './SEO';

// Lazy load heavy sections
const Services = lazy(() => import('./Services'));
const Projects = lazy(() => import('./Projects'));
const FAQ = lazy(() => import('./FAQ'));
const Partners = lazy(() => import('./Partners'));
const Testimonials = lazy(() => import('./Testimonials'));
const LatestArticles = lazy(() => import('./LatestArticles'));
const Contact = lazy(() => import('./Contact'));
const Footer = lazy(() => import('./Footer'));

const Home = () => {
  return (
    <>
      <SEO 
        title="aurora.code - Website Development & Digital Solution"
        description="Jasa pembuatan website profesional di Tulungagung, Trenggalek, Kediri, Blitar dan sekitarnya. Spesialis Web Company Profile, E-Commerce, dan Sistem Informasi Custom dengan desain modern, cepat, dan SEO-friendly."
        keywords="jasa pembuatan website tulungagung, jasa website tulungagung, website developer tulungagung, jasa pembuatan website trenggalek, jasa website trenggalek, website developer trenggalek, jasa pembuatan website kediri, jasa website kediri, website developer kediri, jasa pembuatan website blitar, jasa website blitar, website developer blitar, jasa pembuatan website jawa timur, web developer profesional, aurora code, jasa pembuatan website toko online, jasa pembuatan website sistem informasi, jasa pembuatan website custom, jasa pembuatan website murah, jasa pembuatan website terbaik, jasa pembuatan website terpercaya, jasa pembuatan website sekolah, jasa pembuatan website umkm, jasa pembuatan website perusahaan"
        url="https://auroracode.tech/"
      />
      <Navbar />
      <Hero />
      
      <div id="services">
        <React.Suspense fallback={<div className="section-loader">Loading...</div>}>
          <Services />
        </React.Suspense>
      </div>

      <LazySection id="partners">
        <Partners />
      </LazySection>
      
      <LazySection id="projects">
        <Projects />
      </LazySection>

      <LazySection id="testimonials">
        <Testimonials />
      </LazySection>

      <LazySection id="latest-articles">
        <LatestArticles />
      </LazySection>
      
      <LazySection id="faq">
        <FAQ />
      </LazySection>
      
      <LazySection id="contact">
        <Contact />
      </LazySection>
      
      <LazySection>
        <Footer />
      </LazySection>
    </>
  );
};

export default Home;
